/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StorageUrlDto } from '../../models/storage-url-dto';

export interface GetStorageObjectUrl$Params {
  id: string;
  temporary?: boolean | null;
  compressionType?: string;
}

export function getStorageObjectUrl(http: HttpClient, rootUrl: string, params: GetStorageObjectUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageUrlDto>> {
  const rb = new RequestBuilder(rootUrl, getStorageObjectUrl.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('temporary', params.temporary, {});
    rb.query('compressionType', params.compressionType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StorageUrlDto>;
    })
  );
}

getStorageObjectUrl.PATH = '/v0/storageObjects/{id}/url';
